export default "__VITE_ASSET__0pN2eXin__"